var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RaitingTop',{attrs:{"company-top":_vm.company_top,"region-top":_vm.region_top,"reservoir-top":_vm.reservoir_top}}),_c('FishListPercentage',{attrs:{"fish-top":_vm.fish_top}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }